module.exports = __webpack_public_path__ + "static/media/2bhk.291fc01a.png";